module.exports = __webpack_public_path__ + "static/media/moon-stars.952e63cd.svg";